/* Reference layout enhancements. Native links and forms remain the fallback. */
(() => {
  'use strict';
  const desktop = window.matchMedia('(min-width: 1000px)');
  const mobileDelivery = root => {
    root.querySelectorAll('.es-delivery__item').forEach(item => { item.open = desktop.matches; });
  };
  const closeFilters = except => {
    document.querySelectorAll('.es-filter-bar .collection__filter-group-name[aria-expanded="true"]').forEach(button => {
      if (button !== except) button.click();
    });
  };
  document.addEventListener('click', event => {
    if (desktop.matches && !event.target.closest('.es-filter-bar')) closeFilters();
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && desktop.matches) {
      const activeButton = document.activeElement.closest?.('.es-filter-bar')?.querySelector('.collection__filter-group-name[aria-expanded="true"]');
      closeFilters();
      activeButton?.focus();
    }
  });
  // Swym's documented callback and dynamic-collection event keep the installed app in charge.
  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(swat => {
    const initialize = () => { if (typeof swat.initializeActionButtons === 'function') swat.initializeActionButtons('.es-storefront .product-list,.es-storefront .product-gallery__carousel-wrapper'); };
    initialize();
    document.addEventListener('swym:collections-loaded', initialize);
  });
  // Warehouse replaces catalog fragments after filters, sort and history changes.
  const main = document.getElementById('main');
  if (main) new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('.product-list,.product-item,.es-gallery-wishlist') || node.querySelector('.product-list,.product-item,.es-gallery-wishlist'))))) {
      document.dispatchEvent(new CustomEvent('swym:collections-loaded'));
    }
  }).observe(main, {subtree:true,childList:true});
  // Mirror the native buy button. Shopify still owns form validation and cart submission.
  const stickyStates = new WeakMap();
  const initializeSticky = root => {
    root.querySelectorAll('[data-es-sticky-purchase]').forEach(bar => {
      if (stickyStates.has(bar)) return;
      const section = bar.closest('[data-section-type="product"]');
      const button = bar.querySelector('[data-es-sticky-add]');
      const price = bar.querySelector('[data-es-sticky-price]');
      let observed;
      const sync = () => {
        const form = document.getElementById(bar.dataset.productForm);
        const native = form?.querySelector('.product-form__add-button');
        if (!native) { bar.hidden = true; return; }
        if (observed !== native) { observer.disconnect(); observer.observe(native); observed = native; }
        const label = native.textContent.trim(); if (button.textContent !== label) button.textContent = label;
        button.disabled = native.disabled;
        const priceNode = section.querySelector('.es-product-heading .price:not(.price--compare)')?.cloneNode(true); priceNode?.querySelectorAll('.visually-hidden').forEach(node => node.remove()); const amount = priceNode?.textContent.trim() || ''; if (price.textContent !== amount) price.textContent = amount;
        bar.hidden = desktop.matches || native.getBoundingClientRect().bottom >= 0;
      };
      const observer = new IntersectionObserver(sync);
      const mutations = new MutationObserver(sync);
      mutations.observe(section, {childList:true,subtree:true});
      button.addEventListener('click', () => document.getElementById(bar.dataset.productForm)?.querySelector('.product-form__add-button')?.click());
      desktop.addEventListener('change', sync);
      let scrollFrame;
      const onScroll = () => { if (!scrollFrame) scrollFrame = requestAnimationFrame(() => { scrollFrame = null; sync(); }); };
      window.addEventListener('scroll',onScroll,{passive:true});
      const cleanup = event => {
        if (event.target.contains(bar)) { observer.disconnect(); mutations.disconnect(); desktop.removeEventListener('change',sync); window.removeEventListener('scroll',onScroll); cancelAnimationFrame(scrollFrame); document.removeEventListener('shopify:section:unload',cleanup); }
      };
      document.addEventListener('shopify:section:unload',cleanup);
      stickyStates.set(bar,true);
      sync();
    });
  };
  const start = () => { mobileDelivery(document); initializeSticky(document); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
  desktop.addEventListener('change', start);
  document.addEventListener('shopify:section:load', event => { mobileDelivery(event.target); initializeSticky(event.target); });
})();
